module.exports = __webpack_public_path__ + "static/img/resolution-05-512.3ad937f8.png";